import { render, staticRenderFns } from "./premiumDetails.vue?vue&type=template&id=4c327e8a&scoped=true&"
import script from "./premiumDetails.vue?vue&type=script&lang=js&"
export * from "./premiumDetails.vue?vue&type=script&lang=js&"
import style0 from "./premiumDetails.vue?vue&type=style&index=0&id=4c327e8a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c327e8a",
  null
  
)

export default component.exports